import { model as i18nModel } from '!/i18n'
import type { BannerCarousel } from '@setplex/tria-api'
import { api } from '@setplex/tria-api'
import { combine, type Store } from 'effector'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { clearFieldsBanner } from './lib'

// movies + tv + shows. Used on home page
export const $bannersFilledFormatted: Store<BannerCarousel[]> = combine(
  api.banners.$banners,
  ssePurchasesModel.$adjust,
  i18nModel.$t,
  (banners, adjust): BannerCarousel[] =>
    banners.map((banner) => ({
      ...banner,
      bannerBundles: banner.bannerBundles?.map(clearFieldsBanner(adjust)),
    }))
)

// shows
export const $bannersTypeShowFormatted: Store<BannerCarousel[]> = combine(
  api.banners.$bannersTypeTvShow,
  ssePurchasesModel.$adjust,
  i18nModel.$t,
  (banners, adjust): BannerCarousel[] =>
    banners.map((banner) => ({
      ...banner,
      bannerBundles: banner.bannerBundles?.map(clearFieldsBanner(adjust)),
    }))
)

// movies
export const $bannersTypeVodFormatted = combine(
  api.banners.$bannersTypeVod,
  ssePurchasesModel.$adjust,
  i18nModel.$t,
  (banners, adjust): BannerCarousel[] =>
    banners.map((banner) => ({
      ...banner,
      bannerBundles: banner.bannerBundles?.map(clearFieldsBanner(adjust)),
    }))
)

// tv
export const $bannersTypeTvFormatted: Store<BannerCarousel[]> = combine(
  api.banners.$bannersTypeTv,
  ssePurchasesModel.$adjust,
  i18nModel.$t,
  (banners, adjust): BannerCarousel[] =>
    banners.map((banner) => ({
      ...banner,
      bannerBundles: banner.bannerBundles?.map(clearFieldsBanner(adjust)),
    }))
)
